@for (consignment of consignments; track consignment) {
  <div class="cx-list row">
    <div class="cx-list-header col-12">
      <div class="cx-list-status">
        @if (consignment) {
          <span>
            {{
            'orderDetails.deliveryStatus'
            | cxTranslate: { context: consignment.status }
            }}
          </span>
        }
      </div>
      @if (consignment?.statusDate) {
        <div class="cx-list-date">
          <div>{{ consignment?.statusDate | cxDate }}</div>
        </div>
      }
      <cx-consignment-tracking
        [orderCode]="order.code"
        [consignment]="consignment"
        *cxFeature="'consignmentTracking'"
        >
      </cx-consignment-tracking>
    </div>
    <div class="cx-list-item col-12">
      <cx-cart-item-list
        [items]="consignment.entries"
        [readonly]="true"
        [promotionLocation]="promotionLocation"
      ></cx-cart-item-list>
    </div>
  </div>
}
